import React from "react";
import { Modal } from "react-bootstrap";

/**
 * This component is used to show dialog box
 */
class DialogBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div>
        <Modal show={this.props.show_modal.show} onHide={this.props.hide_modal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.props.show_modal.data
                ? this.props.show_modal.data.heading
                : ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.props.show_modal.data ? this.props.show_modal.data.body : ""}
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={this.props.hide_modal}
              className="btn-secondary filter-btn"
            >
              No
            </button>
            <button
              className="filter-btn bg-blue"
              onClick={() =>
                this.props.onSubmit(this.props.show_modal.data.rowId)
              }
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
export default DialogBox;
